export const drinksData = [
  {
    category: "Cocktails",
    name: "Tokyo Breeze",
    price: 18,
    description:
      "From the first sip to the last, our Citrus Sake Sparkle dances on your palate, offering a symphony of tastes. The sake provides a delicate and smooth base, while the yuzu juice brightens the cocktail with its citrus tang. The blackberry adds a sweet complexity, and with each sip, the yuzu foam teases your senses with its delightful effervescence.",
    category_fr: "Cocktails",
    name_fr: "Brise de Tokyo",
    description_fr:
      "De la première gorgée à la dernière, le saké citronnelle danse sur votre palais, offrant une symphonie de saveurs. Le saké offre une base délicate et onctueuse, tandis que le jus de yuzu égaye le cocktail avec sa saveur d’agrumes. La mure ajoute une douce complexité, et à chaque gorgée, la mousse de yuzu taquine vos sens avec sa délicieuse effervescence.",
  },
  {
    category: "Cocktails",
    name: "Celestial Cloud Martini",
    price: 20,
    description:
      "The white tea air cloud envelops your seances in a symphony of flavors. The white tea-infused gin lends a smooth and refined botanical melody, while the white tea syrup provides a subtle sweetness, harmonizing with the brightness of fresh lemon juice. The egg white imbues a luxurious creaminess, creating a heavenly texture that glides across your palate.",
    category_fr: "Cocktails",
    name_fr: "Martini Nuage Céleste",
    description_fr:
      "Le nuage d’air du thé blanc enveloppe vos séances d’une symphonie de saveurs. Le gin infusé au thé blanc prête une mélodie vegetale douce et refinee, tandis que le sirop de the blanc apporte une douceur subtile, s’harmonisant avec l’éclat du jus de citron frais. Le blanc d’oeuf confère une onctuosité luxueuse, créant une texture paradisaique qui glisse sur votre palais.",
  },
  {
    category: "Cocktails",
    name: "Vanilla Fig Fizz",
    price: 18,
    description:
      "Prepare to be whisked away on a tantalizing journey of flavor with our signature concoction, the Vanilla Fig Fizz. Crafted with passion and creativity, this cocktail blends the smooth essence of vodka infused with Madagascar vanilla bean, the luscious sweetness of fig syrup, and the zesty brightness of freshly squeezed lemon juice. Topped off with a playful surprise of popping candy, this enchanting creation promises to delight your taste buds and ignite your senses.",
    category_fr: "Cocktails",
    name_fr: "Figues à la Vanille",
    description_fr:
      "Préparez-vous à être emporté dans un voyage de saveurs alléchantes avec notre concoction signature, le Figues à la Vanille. Fabriqué avec passion et créativité, ce cocktail associe l’essence douce de la vodka infusée à la gousse de vanille de Madagascar, la douceur succulente du sirop de figue et zeste brillant du jus de citron fraîchement pressé. Surmontée d’une surprise ludique faite de bonbons pétillants, cette création enchanteresse promet de ravir vos papilles et d’enflammer vos sens.",
  },
  {
    category: "Cocktails",
    name: "Zen Garden",
    price: 18,
    description:
      "Embark on a refreshing and invigorating journey with our Shiso Strawberry Zing, a unique and artfully crafted cocktail that celebrates the exquisite fusion of Japanese-inspired ingredients. This captivating elixir features a harmonious blend of strawberry and shiso leaves infused gin, intensified with yuzu concentrate, and delicately garnished with lemongrass-infused shochu and a vibrant shiso leaf.",
    category_fr: "Cocktails",
    name_fr: "Jardin Zen",
    description_fr:
      "Embarquez pour un voyage rafraîchissant et revigorant avec notre Jardin Zen, un cocktail unique et astucieusement conçu qui célèbre la fusion exquise d'ingrédients d’inspiration japonaise. Cet élixir captivant présente un mélange harmonieux de gin infusé de feuilles de fraise et de shiso, intensifié avec un concentré de yuzu, et délicatement garni de sochu infusé à la citronnelle et d’une feuille de shiso vigoureuse.",
  },
  {
    category: "Cocktails",
    name: "Cherry Blossom",
    price: 22,
    description:
      "Welcome to a realm of artisanal alchemy, where tradition meets innovation, and taste knows no bonds. Our inhouse crafted Cherry Blossom vermouth with vaporizer finish is an extraordinary libation that promises to take your palate on a journey of sublime flavors.",
    category_fr: "Cocktails",
    name_fr: "Fleur de Cerisier",
    description_fr:
      "Bienvenue dans un royaume d’alchimie artisanale, ou la tradition rencontre l’innovation, et où le goût ne connaît pas de limites. Notre vermouth aux fleurs de cerisier, de notre propre fabrication et  vaporisé, donne naissance à une  libération extraordinaire qui promet de propulser votre palais dans un voyage de saveurs sublimes.",
  },
  {
    category: "Cocktails",
    name: "Mystic Smoke Sphere",
    price: 5,
    description:
      "Indulge in a captivating sensory experience with our signature Smoke Ice Ball. A true celebration of craftsmanship and innovation, this exquisite concoction takes your whisky journey to new heights.",
    category_fr: "Cocktails",
    name_fr: "Sphère De Fumée Mystique",
    description_fr:
      "Offrez-vous une expérience sensorielle captivante avec notre signature Sphère de Fumée Mystique. Véritable célébration de l’artisanat et de l’innovation, cette concoction exquise propulse votre aventure au pays du whisky vers de nouveaux sommets.",
  },
  {
    category: "Mocktails",
    name: "Citrus Basil Bliss",
    price: 12,
    description:
      "Immerse yourself in the refreshing and invigorating Citrus Basil Bliss, a tantalizing mocktail that fuses the vibrant flavors of lemongrass basil syrup, delicate white tea, zesty lemon juice. Adorned with a fragrant basil garnish, this concoction is guaranteed to transport your taste buds to a state of pure bliss.",
    category_fr: "Mocktails",
    name_fr: "Extase D’agrumes Et Basilic Basilic Agrumes",
    description_fr:
      "Plongez-vous dans l’Extase d’Agrumes et Basilic rafraichissant et revigorant, un cocktail sans alcohol alléchant qui fusionne les saveurs vibrantes du sirop de basilic à celles de la citronnelle, du delicat thé blanc et du jus de citron zesté. Ornée d’une garniture  basilic parfumé, cette concoction est assurée de transporter vos papilles dans un état de pur bonheur.",
  },
  {
    category: "Mocktails",
    name: "Berry Zest Fizz",
    price: 12,
    description:
      "Indulge in the captivating flavors of the Berry Zest Fizz, a delightful mocktail that artfully blends the sweetness of blueberries, the warming kick of ginger, the aromatic essence of rosemary, the tangy zest of lemon juice, and the rich earthiness of maple syrup. Topped up with invigorating soda, this effervescent elixir promises to be a refreshing and enchanting experience that will leave you yearning for more.",
    category_fr: "Mocktails",
    name_fr: "Fizz Aux Zeste De Baies",
    description_fr:
      "Laissez-vous tenter par les saveurs captivantes du Fizz au Zeste de Baies, un cocktail sans alcool qui mélange astucieusement la douceur des myrtilles, la chaleur du gingembre, l’essence aromatique du romarin, le zeste acidulé du jus de citron et le goût riche et terreux du sirop d'érable. Complété par un soda revigorant, cet élixir effervescent promet d'être une expérience rafraîchissante et enchanteresse qui vous laissera en suspens.",
  },
  {
    category: "Mocktails",
    name: "Sakura Frost",
    price: 12,
    description:
      "The Sakura Sparkle Mocktail combines delicate Sakura powder and fresh seasonal fruits with refreshing Yakults and top up with a zesty 7up. It offers a harmonious blend and fruity flavors, creating a delightful and fizzy non-alcoholic drink.",
    category_fr: "Mocktails",
    name_fr: "Sakura Givré",
    description_fr:
      "Le Sakura Givré combine la délicate poudre de sakura et des fruits saisonniers, à des  Yakults rafraîchissants, le tout complété avec l’effervescence du  7up. Il offre un mélange harmonieux et des saveurs fruitées, créant une boisson non alcoolisée délicieuse et pétillante.",
  },
  // {
  //   category: "VODKA",
  //   name: "Haku Vodka",
  //   price_gl: 15,
  //   price_btl: 220,
  //   description: "Smooth and refined vodka.",
  //   category_fr: "VODKA",
  //   name_fr: "Haku Vodka",
  // },
  // {
  //   category: "VODKA",
  //   name: "Aupale",
  //   price_gl: 12,
  //   price_btl: 180,
  //   description: "Description for Aupale.",
  //   category_fr: "VODKA",
  //   name_fr: "Aupale",
  // },
  // {
  //   category: "VODKA",
  //   name: "Grey Goose",
  //   price_gl: 15,
  //   price_btl: 220,
  //   description: "Description for Grey Goose.",
  //   category_fr: "VODKA",
  //   name_fr: "Grey Goose",
  // },
  // {
  //   category: "VODKA",
  //   name: "Chopin",
  //   price_gl: 15,
  //   price_btl: 220,
  //   description: "Description for Chopin.",
  //   category_fr: "VODKA",
  //   name_fr: "Chopin",
  // },
  // {
  //   category: "GIN",
  //   name: "Roku Gin",
  //   price_gl: 12,
  //   price_btl: 180,
  //   description: "Description for Roku Gin.",
  //   category_fr: "GIN",
  //   name_fr: "Roku Gin",
  // },
  // {
  //   category: "GIN",
  //   name: "Empress 1908",
  //   price_gl: 15,
  //   price_btl: 220,
  //   description: "Description for Empress 1908.",
  //   category_fr: "GIN",
  //   name_fr: "Empress 1908",
  // },
  // {
  //   category: "GIN",
  //   name: "Hendrick’s",
  //   price_gl: 15,
  //   price_btl: 220,
  //   description: "Description for Hendrick’s.",
  //   category_fr: "GIN",
  //   name_fr: "Hendrick’s",
  // },
  // {
  //   category: "GIN",
  //   name: "Bombay Sapphire",
  //   price_gl: 12,
  //   price_btl: 180,
  //   description: "Description for Bombay Sapphire.",
  //   category_fr: "GIN",
  //   name_fr: "Bombay Sapphire",
  // },
  // {
  //   category: "RUM",
  //   name: "Brugal Anejo Superior",
  //   price_gl: 12,
  //   price_btl: 180,
  //   description: "Description for Brugal Anejo Superior.",
  //   category_fr: "RUM",
  //   name_fr: "Brugal Anejo Superior",
  // },
  // {
  //   category: "RUM",
  //   name: "Brugal Extra Dry",
  //   price_gl: 12,
  //   price_btl: 180,
  //   description: "Description for Brugal Extra Dry.",
  //   category_fr: "RUM",
  //   name_fr: "Brugal Extra Dry",
  // },
  // {
  //   category: "RUM",
  //   name: "Diplomatico Reserva",
  //   price_gl: 15,
  //   price_btl: 180,
  //   description: "Description for Diplomatico Reserva.",
  //   category_fr: "RUM",
  //   name_fr: "Diplomatico Reserva",
  // },
  // {
  //   category: "RUM",
  //   name: "Plantation Original Dark",
  //   price_gl: 15,
  //   price_btl: 180,
  //   description: "Description for Plantation Original Dark.",
  //   category_fr: "RUM",
  //   name_fr: "Plantation Original Dark",
  // },
  // {
  //   category: "RUM",
  //   name: "Plantation O.F.T.D",
  //   price_gl: 15,
  //   price_btl: 220,
  //   description: "Description for Plantation O.F.T.D.",
  //   category_fr: "RUM",
  //   name_fr: "Plantation O.F.T.D",
  // },
  // {
  //   category: "RUM",
  //   name: "Bambu",
  //   price_gl: 15,
  //   price_btl: 220,
  //   description: "Description for Bambu.",
  //   category_fr: "RUM",
  //   name_fr: "Bambu",
  // },
  // {
  //   category: "TEQUILA",
  //   name: "Hornito Plata",
  //   price_gl: 12,
  //   price_btl: 180,
  //   description: "Description for Hornito Plata.",
  //   category_fr: "TEQUILA",
  //   name_fr: "Hornito Plata",
  // },
  // {
  //   category: "TEQUILA",
  //   name: "Casamigos Reposado",
  //   price_gl: 18,
  //   price_btl: 300,
  //   description: "Description for Casamigos Reposado.",
  //   category_fr: "TEQUILA",
  //   name_fr: "Casamigos Reposado",
  // },
  // {
  //   category: "TEQUILA",
  //   name: "Casamigo Anejo",
  //   price_gl: 20,
  //   price_btl: 325,
  //   description: "Description for Casamigo Anejo.",
  //   category_fr: "TEQUILA",
  //   name_fr: "Casamigo Anejo",
  // },
  // {
  //   category: "TEQUILA",
  //   name: "Clase Azul Reposado",
  //   price_gl: 45,
  //   price_btl: 800,
  //   description: "Description for Clase Azul Reposado.",
  //   category_fr: "TEQUILA",
  //   name_fr: "Clase Azul Reposado",
  // },
  // {
  //   category: "TEQUILA",
  //   name: "Clase Azul Gold",
  //   price_gl: 95,
  //   price_btl: 1750,
  //   description: "Description for Clase Azul Gold.",
  //   category_fr: "TEQUILA",
  //   name_fr: "Clase Azul Gold",
  // },
  {
    category: "Whisky",
    name: "Suntory Toki",
    price_gl: 15,
    price_btl: 220,
    description: "Description for Suntory Toki.",
    category_fr: "Whisky",
    name_fr: "Suntory Toki",
  },
  {
    category: "Whisky",
    name: "Kurayoshi Sherry Cask",
    price_gl: 20,
    price_btl: 300,
    description: "Description for Kurayoshi Sherry Cask.",
    category_fr: "Whisky",
    name_fr: "Kurayoshi Sherry Cask",
  },
  {
    category: "Whisky",
    name: "Togouchi Pure Malt",
    price_gl: 20,
    price_btl: 300,
    description: "Description for Togouchi Pure Malt.",
    category_fr: "Whisky",
    name_fr: "Togouchi Pure Malt",
  },
  {
    category: "Whisky",
    name: "Kaiyo Cask Strength",
    price_gl: 22,
    price_btl: 320,
    description: "Description for Kaiyo Cask Strength.",
    category_fr: "Whisky",
    name_fr: "Kaiyo Cask Strength",
  },
  {
    category: "Whisky",
    name: "Kaiyo Japanese Mizunara Oak",
    price_gl: 20,
    price_btl: 300,
    description: "Description for Kaiyo Japanese Mizunara Oak.",
    category_fr: "Whisky",
    name_fr: "Kaiyo Japanese Mizunara Oak",
  },
  {
    category: "Whisky",
    name: "Nikka Miyagikyo Single Malt",
    price_gl: 18,
    price_btl: 280,
    description: "Description for Nikka Miyagikyo Single Malt.",
    category_fr: "Whisky",
    name_fr: "Nikka Miyagikyo Single Malt",
  },
  {
    category: "Whisky",
    name: "Nikka Yoshi Single Malt",
    price_gl: 18,
    price_btl: 280,
    description: "Description for Nikka Yoshi Single Malt.",
    category_fr: "Whisky",
    name_fr: "Nikka Yoshi Single Malt",
  },
  {
    category: "Whisky",
    name: "Shinobu Pure Malt 15YO",
    price_gl: 32,
    price_btl: 620,
    description: "Description for Shinobu 15YO Pure Malt.",
    category_fr: "Whisky",
    name_fr: "Shinobu Pure Malt 15 ans",
  },
  {
    category: "Whisky",
    name: "Shinobu Japanese Blended",
    price_gl: 15,
    price_btl: 220,
    description: "Description for Shinobu Japanese Blended.",
    category_fr: "Whisky",
    name_fr: "Shinobu Japanese Blended",
  },
  {
    category: "Whisky",
    name: "Nikka Taketsuru Pure Malt",
    price_gl: 18,
    price_btl: 240,
    description: "Description for Nikka Taketsuru Pure Malt.",
    category_fr: "Whisky",
    name_fr: "Nikka Taketsuru Pure Malt",
  },
  {
    category: "Whisky",
    name: "Togouchi Japanese Blended 9YO",
    price_gl: 20,
    price_btl: 300,
    description: "Description for Togouchi 9YO Japanese Blended.",
    category_fr: "Whisky",
    name_fr: "Togouchi Japanese Blended 9 ans",
  },
  {
    category: "Whisky",
    name: "Matsui Sakura Cask Single Malt",
    price_gl: 20,
    price_btl: 300,
    description: "Description for Matsui Sakura Cask Single Malt.",
    category_fr: "Whisky",
    name_fr: "Matsui Sakura Cask Single Malt",
  },
  {
    category: "Whisky",
    name: "Shinobu Pure Malt 10YO",
    price_gl: 22,
    price_btl: 320,
    description: "Description for Shinobu 10YO Pure Malt.",
    category_fr: "Whisky",
    name_fr: "Shinobu Pure Malt 10 ans",
  },
  {
    category: "Whisky",
    name: "Mars Shinshu Distillery Iwai Tradition",
    price_gl: 18,
    price_btl: 280,
    description: "Description for Mars Shinshu Distillery Iwai Tradition.",
    category_fr: "Whisky",
    name_fr: "Mars Shinshu Distillery Iwai Tradition",
  },
  {
    category: "Whisky",
    name: "Matsui Kurayoshi Pure Malt 12YO",
    price_gl: 22,
    price_btl: 320,
    description: "Description for Matsui Kurayoshi Pure Malt 12YO.",
    category_fr: "Whisky",
    name_fr: "Matsui Kurayoshi Pure Malt 12 ans",
  },
  {
    category: "Whisky",
    name: "Matsui Single Malt Mizunara Cask",
    price_gl: 22,
    price_btl: 320,
    description: "Description for Matsui Single Malt Mizunara Cask.",
    category_fr: "Whisky",
    name_fr: "Matsui Single Malt Mizunara Cask",
  },
  {
    category: "Whisky",
    name: "Matsui Peated Single Malt Japanese",
    price_gl: 20,
    price_btl: 300,
    description: "Description for Matsui Peated Single Malt Japanese.",
    category_fr: "Whisky",
    name_fr: "Matsui Peated Single Malt Japanese",
  },
  {
    category: "Whisky",
    name: "Macallan Double Cask 12YO",
    price_gl: 22,
    price_btl: 325,
    description: "Description for Macallan 12YO Double Cask.",
    category_fr: "Whisky",
    name_fr: "Macallan Double Cask 12 ans",
  },
  {
    category: "Whisky",
    name: "Basil Hayden’s",
    price_gl: 15,
    price_btl: 220,
    description: "Description for Basil Hayden’s.",
    category_fr: "Whisky",
    name_fr: "Basil Hayden’s",
  },
  {
    category: "Sakes",
    name: "Sayuri Nigori",
    price: 32,
    description: "Description for Sayuri Nigori.",
    category_fr: "Sakés",
    name_fr: "Sayuri Nigori",
  },
  {
    category: "Sakes",
    name: "Kita No Sho Junmai Ginjo",
    price: 52,
    description: "Description for Kita No Sho Junmai Ginjo.",
    category_fr: "Sakés",
    name_fr: "Kita No Sho Junmai Ginjo",
  },
  {
    category: "Sakes",
    name: "Kome Dake No Sake Junmai",
    price: 52,
    description: "Description for Kome Dake No Sake Junmai.",
    category_fr: "Sakés",
    name_fr: "Kome Dake No Sake Junmai",
  },
  {
    category: "Sakes",
    name: "Lachamte Sparkling",
    price: 52,
    description: "Description for Lachamte Sparkling.",
    category_fr: "Sakés",
    name_fr: "Lachamte Sparkling",
  },
  {
    category: "Sakes",
    name: "Shiki No Saké",
    price: 52,
    description: "Description for Shiki No Saké.",
    category_fr: "Sakés",
    name_fr: "Shiki No Saké",
  },
  {
    category: "Sakes",
    name: "Sanka Junmai Daiginjo",
    price: 62,
    description: "Description for Sanka Junmai Daiginjo.",
    category_fr: "Sakés",
    name_fr: "Sanka Junmai Daiginjo",
  },
  {
    category: "Sakes",
    name: "Harushika Sakura",
    price: 68,
    description: "Description for Harushika Sakura.",
    category_fr: "Sakés",
    name_fr: "Harushika Sakura",
  },
  {
    category: "Sakes",
    name: "Saika Ume",
    price: 78,
    description: "Description for Saika Ume.",
    category_fr: "Sakés",
    name_fr: "Saika Ume",
  },
  {
    category: "Sakes",
    name: "Saika Yuzushu",
    price: 88,
    description: "Description for Saika Yuzushu.",
    category_fr: "Sakés",
    name_fr: "Saika Yuzushu",
  },
  {
    category: "Sakes",
    name: "Sanzen Omachi Tok Junmai",
    price: 88,
    description: "Description for Sanzen Omachi Tok Junmai.",
    category_fr: "Sakés",
    name_fr: "Sanzen Omachi Tok Junmai",
  },
  {
    category: "Sakes",
    name: "Zaku Gen No Tomo",
    price:108,
    description: "Description for Zaku Gen No Tomo.",
    category_fr: "Sakés",
    name_fr: "Zaku Gen No Tomo",
  },
  {
    category: "Sakes",
    name: "Utakagi Mugi Shochu",
    price:128,
    description: "Description for Utakagi Mugi Shochu.",
    category_fr: "Sakés",
    name_fr: "Utakagi Mugi Shochu",
  },
  {
    category: "Sakes",
    name: "Karaku Junmai Ginjo Iwai",
    price:128,
    description: "Description for Karaku Junmai Ginjo Iwai.",
    category_fr: "Sakés",
    name_fr: "Karaku Junmai Ginjo Iwai",
  },
  {
    category: "Sakes",
    name: "Dassai 45 Junmai Daiginjo",
    price:138,
    description: "Description for Dassai 45 Junmai Daiginjo.",
    category_fr: "Sakés",
    name_fr: "Dassai 45 Junmai Daiginjo",
  },
  {
    category: "Sakes",
    name: "Hideyoshi Junmai Daiginjo",
    price:168,
    description: "Description for Hideyoshi Junmai Daiginjo.",
    category_fr: "Sakés",
    name_fr: "Hideyoshi Junmai Daiginjo",
  },
  {
    category: "Sakes",
    name: "Morinokura Junmai Daiginjo",
    price:188,
    description: "Description for Morinokura Junmai Daiginjo.",
    category_fr: "Sakés",
    name_fr: "Morinokura Junmai Daiginjo",
  },
  {
    category: "Sakes",
    name: "Karaku Junmai Daiginjo Iwai",
    price:188,
    description: "Description for Karaku Junmai Daiginjo Iwai.",
    category_fr: "Sakés",
    name_fr: "Karaku Junmai Daiginjo Iwai",
  },
  {
    category: "Sakes",
    name: "Dassia 39 Junmai Daiginjo",
    price:198,
    description: "Description for Dassia 39 Junmai Daiginjo.",
    category_fr: "Sakés",
    name_fr: "Dassia 39 Junmai Daiginjo",
  },
  {
    category: "Sakes",
    name: "Kinra Kurobe Cho-Karakuchi",
    price:215,
    description: "Description for Kinra Kurobe Cho-Karakuchi.",
    category_fr: "Sakés",
    name_fr: "Kinra Kurobe Cho-Karakuchi",
  },
  {
    category: "Sakes",
    name: "Urakasumi Honjozo",
    price:215,
    description: "Description for Urakasumi Honjozo.",
    category_fr: "Sakés",
    name_fr: "Urakasumi Honjozo",
  },
  {
    category: "Sakes",
    name: "Tanaka 1789 X Chartier Pavillon of Blend 001 2019",
    price:228,
    description:
      "Description for Tanaka 1789 X Chartier Pavillon of Blend 001 2019.",
    category_fr: "Sakés",
    name_fr: "Tanaka 1789 X Chartier Pavillon of Blend 001 2019",
  },
  {
    category: "Sakes",
    name: "Dassai 23 Junmai Daiginjo",
    price:328,
    description: "Description for Dassai 23 Junmai Daiginjo.",
    category_fr: "Sakés",
    name_fr: "Dassai 23 Junmai Daiginjo",
  },
  {
    category: "Sakes",
    name: "Brilliant Soul Junmai Daiginjo",
    price:498,
    description: "Description for Brilliant Soul Junmai Daiginjo.",
    category_fr: "Sakés",
    name_fr: "Brilliant Soul Junmai Daiginjo",
  },
  // {
  //   category: "SCOTCH",
  //   name: "Glenfarclas 15YO",
  //   price_gl: 20,
  //   price_btl: 300,
  //   description: "Description for Glenfarclas 15YO.",
  //   category_fr: "SCOTCH",
  //   name_fr: "Glenfarclas 15 ans",
  // },
  // {
  //   category: "SCOTCH",
  //   name: "Auchentoshan 12YO",
  //   price_gl: 18,
  //   price_btl: 300,
  //   description: "Description for Auchentoshan 12YO.",
  //   category_fr: "SCOTCH",
  //   name_fr: "Auchentoshan 12 ans",
  // },
  // {
  //   category: "SCOTCH",
  //   name: "Glenfiddich Bourbon Barrel Reserve 14YO",
  //   price_gl: 18,
  //   price_btl: 300,
  //   description: "Description for Glenfiddich 14 YO Bourbon Barrel Reserve.",
  //   category_fr: "SCOTCH",
  //   name_fr: "Glenfiddich Bourbon Barrel Reserve 14 ans",
  // },
  // {
  //   category: "SCOTCH",
  //   name: "Johnnie Walker Blue Label",
  //   price_gl: 45,
  //   price_btl: 880,
  //   description: "Description for Johnnie Walker Blue Label.",
  //   category_fr: "SCOTCH",
  //   name_fr: "Johnnie Walker Blue Label",
  // },
  // {
  //   category: "COGNAC/BRANDY",
  //   name: "Remy Martin Louis XIII",
  //   price_gl: 425,
  //   price_btl: 8000,
  //   description: "Description for Remy Martin Louis XIII.",
  //   category_fr: "COGNAC/BRANDY",
  //   name_fr: "Remy Martin Louis XIII",
  // },
  // {
  //   category: "COGNAC/BRANDY",
  //   name: "Remy Martin XO",
  //   price_gl: 50,
  //   price_btl: 880,
  //   description: "Description for Remy Martin XO.",
  //   category_fr: "COGNAC/BRANDY",
  //   name_fr: "Remy Martin XO",
  // },
  // {
  //   category: "COGNAC/BRANDY",
  //   name: "Remy Martin VSOP",
  //   price_gl: 18,
  //   price_btl: 300,
  //   description: "Description for Remy Martin VSOP.",
  //   category_fr: "COGNAC/BRANDY",
  //   name_fr: "Remy Martin VSOP",
  // },
  // {
  //   category: "LIQUOR",
  //   name: "Harvey’s Bristol Cream",
  //   price_gl: 12,
  //   description: "Description for Harvey’s Bristol Cream.",
  //   category_fr: "LIQUEUR",
  //   name_fr: "Harvey’s Bristol Cream",
  // },
  // {
  //   category: "LIQUOR",
  //   name: "Cynar",
  //   price_gl: 12,
  //   description: "Description for Cynar.",
  //   category_fr: "LIQUEUR",
  //   name_fr: "Cynar",
  // },
  // {
  //   category: "LIQUOR",
  //   name: "Lilet",
  //   price_gl: 12,
  //   description: "Description for Lilet.",
  //   category_fr: "LIQUEUR",
  //   name_fr: "Lilet",
  // },
  // {
  //   category: "LIQUOR",
  //   name: "Crème de Menthe Blanche",
  //   price_gl: 12,
  //   description: "Description for Crème de Menthe Blanche.",
  //   category_fr: "LIQUEUR",
  //   name_fr: "Crème de Menthe Blanche",
  // },
  // {
  //   category: "LIQUOR",
  //   name: "Creme de Menthe Verte",
  //   price_gl: 12,
  //   description: "Description for Creme de Menthe Verte.",
  //   category_fr: "LIQUEUR",
  //   name_fr: "Creme de Menthe Verte	",
  // },
  // {
  //   category: "LIQUOR",
  //   name: "Sambuca Ramazzotti",
  //   price_gl: 12,
  //   description: "Description for Sambuca Ramazzotti.",
  //   category_fr: "LIQUEUR",
  //   name_fr: "Sambuca Ramazzotti",
  // },
  // {
  //   category: "LIQUOR",
  //   name: "Sambuca Ramazzotti Black",
  //   price_gl: 12,
  //   description: "Description for Sambuca Ramazzotti Black.",
  //   category_fr: "LIQUEUR",
  //   name_fr: "Sambuca Ramazzotti Black",
  // },
  // {
  //   category: "LIQUOR",
  //   name: "Aperol",
  //   price_gl: 14,
  //   description: "Description for Aperol.",
  //   category_fr: "LIQUEUR",
  //   name_fr: "Aperol",
  // },
  // {
  //   category: "LIQUOR",
  //   name: "Campari",
  //   price_gl: 14,
  //   description: "Description for Campari.",
  //   category_fr: "LIQUEUR",
  //   name_fr: "Campari",
  // },
  // {
  //   category: "LIQUOR",
  //   name: "Nonino grappa Chardonnay",
  //   price_gl: 17,
  //   price_btl: 650,
  //   description: "Description for Nonino grappa Chardonnay.",
  //   category_fr: "LIQUEUR",
  //   name_fr: "Nonino grappa Chardonnay",
  // },
  // {
  //   category: "LIQUOR",
  //   name: "Nonino grappa Moscato",
  //   price_gl: 17,
  //   price_btl: 650,
  //   description: "Description for Nonino grappa Moscato.",
  //   category_fr: "LIQUEUR",
  //   name_fr: "Nonino grappa Moscato",
  // },
  // {
  //   category: "LIQUOR",
  //   name: "Amaro",
  //   price_gl: 15,
  //   price_btl: 220,
  //   description: "Description for Amaro.",
  //   category_fr: "LIQUEUR",
  //   name_fr: "Amaro",
  // },
  // {
  //   category: "LIQUOR",
  //   name: "Eligo dell’Ornellaia",
  //   price_gl: 18,
  //   price_btl: 300,
  //   description: "Description for Eligo dell’Ornellaia.",
  //   category_fr: "LIQUEUR",
  //   name_fr: "Eligo dell’Ornellaia",
  // },
  // {
  //   category: "LIQUOR",
  //   name: "Limone Finissimo Rosolio di Limoni Sicilia",
  //   price_gl: 12,
  //   price_btl: 180,
  //   description: "Description for Limone Finissimo Rosolio di Limoni Sicilia.",
  //   category_fr: "LIQUEUR",
  //   name_fr: "Limone Finissimo Rosolio di Limoni Sicilia",
  // },
  // {
  //   category: "LIQUOR",
  //   name: "Grand Marnier",
  //   price_gl: 12,
  //   description: "Description for Grand Marnier.",
  //   category_fr: "LIQUEUR",
  //   name_fr: "Grand Marnier",
  // },
  // {
  //   category: "LIQUOR",
  //   name: "Grand Marnier Cuvée du Centenaire",
  //   price_gl: 25,
  //   description: "Description for Grand Marnier Cuvée du Centenaire.",
  //   category_fr: "LIQUEUR",
  //   name_fr: "Grand Marnier Cuvée du Centenaire",
  // },
  // {
  //   category: "LIQUOR",
  //   name: "Belle de Brillet",
  //   price_gl: 15,
  //   price_btl: 220,
  //   description: "Description for Belle de Brillet.",
  //   category_fr: "LIQUEUR",
  //   name_fr: "Belle de Brillet",
  // },
  // {
  //   category: "LIQUOR",
  //   name: "Pimm’s No 1 Original",
  //   price_gl: 12,
  //   description: "Description for Pimm’s No 1 Original.",
  //   category_fr: "LIQUEUR",
  //   name_fr: "Pimm’s No 1 Original",
  // },
  // {
  //   category: "LIQUOR",
  //   name: "Jagermeister",
  //   price_gl: 12,
  //   price_btl: 180,
  //   description: "Description for Jagermeister.",
  //   category_fr: "LIQUEUR",
  //   name_fr: "Jagermeister",
  // },
  // {
  //   category: "LIQUOR",
  //   name: "Disaronno Original",
  //   price_gl: 12,
  //   description: "Description for Disaronno Original.",
  //   category_fr: "LIQUEUR",
  //   name_fr: "Disaronno Original",
  // },
  // {
  //   category: "PORTO",
  //   name: "Taylor Fladgate Tawny 10YO",
  //   price_gl: 12,
  //   price_btl: 150,
  //   description: "Description for Taylor Fladgate Tawny 10YO.",
  //   category_fr: "PORTO",
  //   name_fr: "Taylor Fladgate Tawny 10 ans",
  // },
  // {
  //   category: "PORT",
  //   name: "Taylor Fladgate Tawny 20YO",
  //   price_gl: 18,
  //   price_btl: 300,
  //   description: "Description for Taylor Fladgate Tawny 20YO.",
  //   category_fr: "PORTO",
  //   name_fr: "Taylor Fladgate Tawny 20 ans",
  // },
  // {
  //   category: "BEER",
  //   name: "Asahi Super Dry 5%, 500ml",
  //   price_gl: 12,
  //   description: "Description for Asahi Super Dry 5%, 500ml.",
  //   category_fr: "BIÈRE",
  //   name_fr: "Asahi Super Dry 5%, 500ml",
  // },
  // {
  //   category: "BEER",
  //   name: "Moosehead Lager 5%, 473ml",
  //   price_gl: 12,
  //   description: "Description for Moosehead Lager 5%, 473ml.",
  //   category_fr: "BIÈRE",
  //   name_fr: "Moosehead Lager 5%,473ml",
  // },
  // {
  //   category: "BEER",
  //   name: "Vizzy Hard Seltzer 5%, 355ml",
  //   price_gl: 12,
  //   description: "Description for Vizzy Hard Seltzer 5%, 355ml.",
  //   category_fr: "BIÈRE",
  //   name_fr: "Vizzy Hard Seltzer 5%, 355ml",
  // },
  // {
  //   category: "BEER",
  //   name: "Les 4 Surfeurs de l'apocalypso IPA Blanche 6.5%, 473ml",
  //   price_gl: 16,
  //   description:
  //     "Description for Les 4 Surfeurs de l'apocalypso IPA Blanche 6.5%, 473ml.",
  //   category_fr: "BIÈRE",
  //   name_fr: "Les 4 Surfeurs de l'apocalypso IPA Blanche  6.5%, 473ml",
  // },
  // {
  //   category: "BEER",
  //   name: "Drunken Dragon, Rice lager with matcha 5%, 473ml",
  //   price_gl: 14,
  //   description:
  //     "Description for Les 4 Surfeurs de l'apocalypso IPA Blanche 6.5%, 473ml.",
  //   category_fr: "BIÈRE",
  //   name_fr: "Drunken Dragon, Bière blonde au riz et matcha 5%, 473ml",
  // },
  // {
  //   category: "WATER",
  //   name: "Acqua Panna 750ml",
  //   price_gl: 9,
  //   description: "Description for Acqua Panna 750ml.",
  //   category_fr: "EAU",
  //   name_fr: "Acqua Panna 750ml",
  // },
  // {
  //   category: "WATER",
  //   name: "S.Pellegrino 750ml",
  //   price_gl: 9,
  //   description: "Description for S.Pellegrino 750ml.",
  //   category_fr: "EAU",
  //   name_fr: "S.Pellegrino 750ml",
  // },
  // {
  //   category: "SOFT DRINKS",
  //   name: "Coca Cola",
  //   price_gl: 5,
  //   description: "Description for Coca Cola.",
  //   category_fr: "BOISSONS GAZEUSES",
  //   name_fr: "Coca Cola",
  // },
  // {
  //   category: "SOFT DRINKS",
  //   name: "Coke Diete",
  //   price_gl: 5,
  //   description: "Description for Coke Diete.",
  //   category_fr: "BOISSONS GAZEUSES",
  //   name_fr: "Coke Diete",
  // },
  // {
  //   category: "SOFT DRINKS",
  //   name: "Sprite",
  //   price_gl: 5,
  //   description: "Description for Sprite.",
  //   category_fr: "BOISSONS GAZEUSES",
  //   name_fr: "Sprite",
  // },
  // {
  //   category: "SOFT DRINKS",
  //   name: "Sprite Zero Lemon-Lime",
  //   price_gl: 5,
  //   description: "Description for Sprite Zero Lemon-Lime.",
  //   category_fr: "BOISSONS GAZEUSES",
  //   name_fr: "Sprite Zero Citron-Lime",
  // },
  // {
  //   category: "SOFT DRINKS",
  //   name: "Tonic",
  //   price_gl: 5,
  //   description: "Description for Tonic.",
  //   category_fr: "BOISSONS GAZEUSES",
  //   name_fr: "Tonic",
  // },
  // {
  //   category: "SOFT DRINKS",
  //   name: "Soda",
  //   price_gl: 5,
  //   description: "Description for Soda.",
  //   category_fr: "BOISSONS GAZEUSES",
  //   name_fr: "Soda",
  // },
  // {
  //   category: "SOFT DRINKS",
  //   name: "Ginger Beer",
  //   price_gl: 5,
  //   description: "Description for Ginger Beer.",
  //   category_fr: "BOISSONS GAZEUSES",
  //   name_fr: "Bière de gingembre",
  // },
  // {
  //   category: "SOFT DRINKS",
  //   name: "Ginger Ale",
  //   price_gl: 5,
  //   description: "Description for Ginger Ale.",
  //   category_fr: "BOISSONS GAZEUSES",
  //   name_fr: "Ginger Ale",
  // },
  // {
  //   category: "JUICE",
  //   name: "Orange Juice",
  //   price_gl: 6,
  //   description: "Description for Orange Juice.",
  //   category_fr: "JUS",
  //   name_fr: "Jus d'Orange",
  // },
  // {
  //   category: "JUICE",
  //   name: "Pineapple",
  //   price_gl: 6,
  //   description: "Description for Pineapple Juice.",
  //   category_fr: "JUS",
  //   name_fr: "Ananas",
  // },
  // {
  //   category: "JUICE",
  //   name: "Cranberry",
  //   price_gl: 6,
  //   description: "Description for Cranberry Juice.",
  //   category_fr: "JUS",
  //   name_fr: "Canneberge",
  // },
  // {
  //   category: "JUICE",
  //   name: "Apple",
  //   price_gl: 6,
  //   description: "Description for Apple Juice.",
  //   category_fr: "JUS",
  //   name_fr: "Pomme",
  // },
  // {
  //   category: "JUICE",
  //   name: "Grape",
  //   price_gl: 6,
  //   description: "Description for Grape Juice.",
  //   category_fr: "JUS",
  //   name_fr: "Raisin",
  // },
  // {
  //   category: "JUICE",
  //   name: "Coconut",
  //   price_gl: 6,
  //   description: "Description for Coconut Juice.",
  //   category_fr: "JUS",
  //   name_fr: "Noix de coco",
  // },
  // {
  //   category: "JUICE",
  //   name: "Clamato",
  //   price_gl: 6,
  //   description: "Description for Clamato.",
  //   category_fr: "JUS",
  //   name_fr: "Clamato",
  // },
  // {
  //   category: "ENERGY DRINK",
  //   name: "Red Bull",
  //   price_gl: 8,
  //   description: "Description for Red Bull.",
  //   category_fr: "BOISSONS ÉNERGISANTES",
  //   name_fr: "Red Bull",
  // },
  // {
  //   category: "ENERGY DRINK",
  //   name: "Red Bull Sugar Free",
  //   price_gl: 8,
  //   description: "Description for Red Bull Sugar Free.",
  //   category_fr: "BOISSONS ÉNERGISANTES",
  //   name_fr: "Red Bull Sugar Free",
  // },
  // {
  //   category: "ENERGY DRINK",
  //   name: "Red Bull Yellow Edition",
  //   price_gl: 8,
  //   description: "Description for Red Bull Yellow Edition.",
  //   category_fr: "BOISSONS ÉNERGISANTES",
  //   name_fr: "Red Bull Yellow Edition",
  // },
  // {
  //   category: "COFFEES",
  //   name: "Americano",
  //   price_gl: 4,
  //   description: "Description for Americano.",
  //   category_fr: "CAFÉS",
  //   name_fr: "Americano",
  // },
  // {
  //   category: "COFFEES",
  //   name: "Espresso",
  //   price_gl: 4,
  //   description: "Description for Espresso.",
  //   category_fr: "CAFÉS",
  //   name_fr: "Espresso",
  // },
  // {
  //   category: "COFFEES",
  //   name: "Double Espresso",
  //   price_gl: 5.5,
  //   description: "Description for Double Espresso.",
  //   category_fr: "CAFÉS",
  //   name_fr: "Double Espresso",
  // },
  // {
  //   category: "COFFEES",
  //   name: "Cappuccino",
  //   price_gl: 5,
  //   description: "Description for Cappuccino.",
  //   category_fr: "CAFÉS",
  //   name_fr: "Cappuccino",
  // },
  // {
  //   category: "COFFEES",
  //   name: "Latte",
  //   price_gl: 5,
  //   description: "Description for Latte.",
  //   category_fr: "CAFÉS",
  //   name_fr: "Latte",
  // },
  // {
  //   category: "COFFEES",
  //   name: "Macchiato",
  //   price_gl: 4.5,
  //   description: "Description for Macchiato.",
  //   category_fr: "CAFÉS",
  //   name_fr: "Macchiato",
  // },
  // {
  //   category: "COFFEES",
  //   name: "Flat White",
  //   price_gl: 5.5,
  //   description: "Description for Flat White.",
  //   category_fr: "CAFÉS",
  //   name_fr: "Flat White",
  // },
  // {
  //   category: "TEAS",
  //   name: "Red Tea, Natural Lychee Flavor",
  //   price_gl: 6,
  //   description:
  //     "Light and smooth taste that is accented by the distinct flavor of lychee. Lychee Red Tea is often enjoyed on its own, without any additions, as its flavor is rich and well-balanced.",
  //   category_fr: "Thés",
  //   name_fr: "Thé Rouge, Arôme Naturel de Litchi",
  //   description_fr:
  //     "Un goût léger et doux  accentué par la saveur distincte du litchi. Le thé rouge au litchi est souvent apprécié seul, sans aucun ajout, car sa saveur est riche et bien équilibrée.",
  // },
  // {
  //   category: "TEAS",
  //   name: "White Tea, Pai Mu Tan",
  //   price_gl: 5,
  //   description:
  //     "The Pai Mu Tan tea is also recognizable by its characteristic long white sheets. Harvested by hand only in spring, this tea has an unparalleled flavor, its particularly refined taste accompanied by a sweet note, releasing an aroma of ripe fruit and flowers.",
  //   category_fr: "Thés",
  //   name_fr: "Thé Blanc, Pai Mu Tan",
  //   description_fr:
  //     "Le thé Pai Mu Tan est également reconnaissable par ses longues feuilles blanches caractéristiques. Récolté à la main uniquement au printemps, ce thé a une saveur inégalée;son goût particulièrement raffiné, accompagné d’une note sucrée, libère un arôme de fruits mûrs et de fleurs.",
  // },
  // {
  //   category: "TEAS",
  //   name: "Dragonwell Premium Green Tea, Lung Ching",
  //   price_gl: 6,
  //   description:
  //     "Rich, toasty aroma reminiscent of roasted chestnuts. Smooth, vegetal flavor with notes of green pepper and fresh cut grass.",
  //   category_fr: "Thés",
  //   name_fr: "Thé Vert Dragonwell Premium, Lung Ching",
  //   description_fr:
  //     "Arôme riche et torréfié rappelant les châtaignes grillées. Saveur douce et végétale avec des notes de poivre vert et d’herbe fraîchement coupée.",
  // },
  // {
  //   category: "TEAS",
  //   name: "Matcha, Ceremonial Grade",
  //   price_gl: 8,
  //   description:
  //     "Mellow vegetal grassy notes, natural sweet nuttiness, a touch of bitterness with a pleasant savory ending.",
  //   category_fr: "Thés",
  //   name_fr: "Matcha, Grade Cérémonial",
  //   description_fr:
  //     "Notes herbacées végétales douces, goût naturel de noisettes sucrées, une touche d'amertume avec une finale savoureuse et agréable.",
  // },
  // {
  //   category: "TEAS",
  //   name: "Matcha Fine Grade",
  //   price_gl: 6,
  //   description:
  //     "High-quality matcha smells like fresh leaves, with a somewhat vegetal aroma, while lower qualities tend to have a stale smell. A high-quality grade should create a very creamy experience in the mouth, umami flavor with a lingering sweet aftertaste.",
  //   category_fr: "Thés",
  //   name_fr: "Matcha Qualité Supérieure",
  //   description_fr:
  //     "Le matcha de qualité supérieure dégage une odeur de feuilles fraîches, alors que les qualités inférieures ont tendance à avoir une odeur de renfermé. Un matcha de qualité supérieure devrait créer une expérience très crémeuse en bouche, une saveur umami avec un arrière-goût sucré persistant.",
  // },
  // {
  //   category: "TEAS",
  //   name: "Ti Kuan Yin, Premium",
  //   price_gl: 6,
  //   description:
  //     "Ti Kuan Yin tea’s flavor profile is often described as floral, slightly sweet, and nutty. The tea has a smooth and creamy texture with a slightly roasted flavor that compliments the natural sweetness. The tea is well-known for its long-lasting aftertaste, which can last for several minutes on the palate.",
  //   category_fr: "Thés",
  //   name_fr: "Ti Kuan Yin, Premium",
  //   description_fr:
  //     "Le profil de saveur du thé Ti Kuan Yin est souvent décrit comme floral, légèrement sucré et noiseté. Le thé a une texture lisse et crémeuse avec une saveur légèrement torréfiée qui complète la douceur naturelle. Le thé est bien connu pour son arrière-goût persistant, qui peut durer plusieurs minutes en bouche.",
  // },
  // {
  //   category: "TEAS",
  //   name: "Blooming Tea, Eternity Jasmine Flower",
  //   price_gl: 14,
  //   description:
  //     "This jasmine green tea is infused with lily flowers to replenish energy, provide a beautiful skin, 		minimize the appearance of wrinkles and relieve  stress and fatigue.",
  //   category_fr: "Thés",
  //   name_fr: "Thé en Fleurs, Fleur de Jasmin D'éternité",
  //   description_fr:
  //     "Ce thé vert au Jasmin est infusé de fleurs de lys pour revivifier, procurer une belle peau, minimiser l’apparence des rides et soulager le stress et la fatigue.",
  // },
];
